import { SpinnerCircular } from "spinners-react";

const OverlaySpinner = () => {
    return <div className="absolute w-full h-full bg-brand-grey-medium opacity-60 flex justify-center items-center z-[100] top-0 left-0">
        <SpinnerCircular size={50} color="#24272b" secondaryColor="white" />
    </div>
}

export default OverlaySpinner;